import MultiService from '@components/IntroPages/MultiService'

export default {
  path: 'multiServiceIntro',
  component: MultiService,
  stat: '多客服宣传页'
}
